// extracted by mini-css-extract-plugin
export default {"tooltip":"zq-z","sharingV2":"Aq-z","sharingIconsV2":"Bq-z","links":"Cq-z","link":"Dq-z","facebookV2":"Eq-z","twitterV2":"Fq-z","pinterestV2":"Gq-z"};